import React, { useState, useEffect } from "react";
import { Grid, StylesProvider, jssPreset, Card } from "@material-ui/core";
import "./style.css";
import { create } from "jss";
import rtl from "jss-rtl";
import { connect } from "react-redux";
import FormSteps from "components/FormSteps";
import getSchema from "utils/setValidationSchema";
import {
  getDraft,
  getFormLayout,
  setFormName,
  handleDraftAssignment,
} from "reducers/form/formActions";
import SpinnerLoader from "components/SpinnerLoader";
import client from "api/apiAuth/guestClient";
import { Alert } from "@material-ui/lab";
import { useParams } from "react-router-dom";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
function ContinueSubmission(props) {
  const {
    getLayout,
    getDraft,
    form,
    match,
    history,
    form_layout_loading,
    setFormName,
    task,
  } = props;
  const params = useParams();
  const [validationSchema, setValidationSchema] = useState({});
  const [draftValidationSchema, setDraftvalidationSchema] = useState({});
  // state of confirm modal
  const { formId, id } = match.params;
  const [initialValues, setInitialValues] = useState({});
  const [remainingTime, setRemainingTime] = useState();
  const [taskData, setTaskData] = useState(null);

  const getRemainingTime = async () => {
    let { data } = await client.get(`/submission/getRemainingTime`, {
      params: { sub_id: id, formId },
    });
    setRemainingTime(data.remaining_time);
  };
  const fetchTask = async () => {
    const response = await client.get("/tasks/taskDetails", {
      params: {
        submission_id: params.id,
        task_status: "Pending",
      },
    });
    setTaskData(response.data.task);
  };
  useEffect(() => {
    if (id) getRemainingTime();
    setInitialValues({});
    getLayout({ formId, submission_id: id });
    setFormName("");
    if (!task) fetchTask();
    else setTaskData(task);
  }, []);
  useEffect(() => {
    if (form) {
      setValidationSchema(getSchema(false));
      setDraftvalidationSchema(getSchema(true));
    }
  }, [form]);

  if (!taskData) return <SpinnerLoader />;

  return (
    <StylesProvider jss={jss}>
      <Grid container spacing={0} direction="row" justifyContent="center">
        <Grid item xs={12} className="form-container ">
          {remainingTime ? (
            <Alert style={{ marginBottom: 5 }} severity="warning">
              The remaining time is {remainingTime}
            </Alert>
          ) : null}
          <Card className="card-box form-container">
            <div className="card-body p-0 ">
              {form_layout_loading ? (
                <SpinnerLoader />
              ) : (
                <>
                  <FormSteps
                    form={form.sections}
                    formId={formId}
                    validationSchema={validationSchema}
                    draftValidationSchema={draftValidationSchema}
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    continueValues={taskData.submission}
                    submissionId={id}
                    history={history}
                    config={{
                      continue: {
                        file_code: taskData.submission.file_code,
                        sub_id: taskData.submission.id,
                      },
                    }}
                  ></FormSteps>
                </>
              )}
            </div>
          </Card>
        </Grid>
      </Grid>
    </StylesProvider>
  );
}
const mapStateToProps = (state) => {
  return {
    task: state.details.task,
    form: state.form.form,
    form_layout_loading: state.form.form_layout_loading,
    user: state.auth.user,
    users: state.details.users,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLayout: (params) => dispatch(getFormLayout(params)),
    getDraft: (params) => dispatch(getDraft(params)),
    setFormName: (name) => dispatch(setFormName(name)),
    handleDraftAssignment: (params, data) =>
      dispatch(handleDraftAssignment(data, params)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ContinueSubmission);
